import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import fetch from 'cross-fetch';
import { DocumentNode } from 'graphql';

interface ApolloClientAdapterArgs {
  [key: string]: unknown;
}

export const apolloClient = (uri: string, fetcher = fetch) => {
  return new ApolloClient({
    link: new HttpLink({
      uri,
      fetch: fetcher,
    }),
    cache: new InMemoryCache(),
  });
};

const apolloClientAdapter =
  <T>(msUri: string, fetcher = fetch) =>
  async (apolloQueryOrMutation: DocumentNode, variables: ApolloClientAdapterArgs): Promise<T> => {
    const apollo = apolloClient(msUri, fetcher);
    try {
      const isMutation = apolloQueryOrMutation.definitions?.[0]?.['operation'] === 'mutation'

      if(isMutation){
        const mutationResponse = await apollo.mutate<T>({
          mutation: apolloQueryOrMutation,
          variables,
          fetchPolicy: 'no-cache'
        })

        return mutationResponse.data
      } else {
        const response = await apollo.query<T>({
          query: apolloQueryOrMutation,
          fetchPolicy: 'no-cache',
          variables,
        });

        return response.data;
      }
    } catch (error) {
      console.error('[ADAPTER] Error executing GraphQL query:', error);
      throw error;
    }
  };

export default apolloClientAdapter;
